<div class="flex flex-col md:flex-row gap-6 items-start md:items-center">
  <div class="flex-shrink-0 relative w-fit mt-4 md:mt-0 mx-auto md:mx-0">
    @if (entity && entityType !== 'club') {
      <div class="absolute z-10" style="bottom: 100%; right: 0.5px;">
        <span [class]="'inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-t-md shadow-md backdrop-blur-sm text-white ' + getStatusBadgeClass()">
          <span class="w-2 h-2 rounded-full bg-white"></span>
          {{ getStatusLabel() }}
        </span>
      </div>
    }

    <div class="w-40 h-40 bg-stone-50 flex items-center justify-center border border-stone-200 overflow-hidden" style="border-radius: 0px;">
      @if (getProfileImage()) {
        <img [src]="getProfileImage()" [alt]="getEntityName()" class="w-full h-full object-cover" />
      } @else {
        <svg class="w-20 h-20 text-stone-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      }
    </div>
  </div>

  <div class="flex-1 min-w-0 w-full">
    <h2 class="text-lg md:text-xl font-semibold text-stone-800 break-words mb-4">{{ getEntityName() }}</h2>

    <div class="fiche-grid">
      <div class="fiche-field">
        <span class="fiche-label-fixed">ID</span>
        <div class="fiche-input-mock">{{ getPlayerCode() }}</div>
      </div>

      @if (entityType !== 'club') {
        <div class="fiche-field">
          <span class="fiche-label-fixed">Date de naissance</span>
          <div class="fiche-input-mock">{{ getDOB() }}</div>
        </div>
      }

      <div class="fiche-field">
        <span class="fiche-label-fixed">Club</span>
        <div class="fiche-input-mock">{{ getClubName() }}</div>
      </div>
    </div>
  </div>
</div>
